import { FunctionComponent, useState } from "react";
import {
  ToastType,
  useToast,
} from "../../../../../context_providers/toast/toast_ctx";
import FileDropZone1 from "../../../../new_components/common/file_dropdown";

export const AttachmentCategory = [
  "PO",
  "E-Bill",
  "Aadhaar Card",
  "PAN Card",
  "Installation Photos",
  "Email",
  "Subsidy Registration Acknowledgement Copy",
  "Facilitation fees Invoice",
  "Customer Review video",
  "Other",
];

interface UploadAttachmentWidgetProps {
  onSubmit: (data: { category: string; file: File }) => void;
  onClose: () => void;
}

const UploadAttachmentWidget: FunctionComponent<UploadAttachmentWidgetProps> = (
  props,
) => {
  const { showToast } = useToast();
  const [category, setCategory] = useState("");
  const [files, setFiles] = useState<File[]>([]); // Changed to array

  const removeFile = (index: number) => {
    setFiles(files.filter((_, i) => i !== index));
  };

  return (
    <>
      <div id="order-create-attachment-upload" className="p-5 flex flex-col">
        <div className="my-2">
          <label
            htmlFor="order-create-attachment-category"
            className=" mb-1 font-semibold text-sm block"
          >
            Attachment category
          </label>
          <select
            value={category}
            onChange={(e) => {
              setCategory(e.target.value);
            }}
            name=""
            id="order-create-attachment-category"
            className=" w-full text-xs  px-3 py-1 cursor-pointer bg-gray-100 rounded focus:outline-none"
          >
            <option hidden>Select</option>
            {AttachmentCategory.map((at, i) => (
              <option key={i} value={at}>
                {at}
              </option>
            ))}
          </select>
        </div>
        <FileDropZone1
          id="order-create-attachment-file-input"
          type="image/*,application/pdf"
          onChange={(f) => {
            setFiles([...files, ...f]); // Add new files to existing array
          }}
          multiSelect={true} // Enable multiple file selection
        ></FileDropZone1>

        {files.length > 0 && (
          <>
            <div className="my-3 text-sm font-semibold">
              {files.length} file(s) selected
            </div>
            <div className="max-h-96 overflow-y-auto space-y-3 mb-5">
              {files.map((file, index) => (
                <div
                  key={index}
                  id={`order-create-attachment-selected-file-${index}`}
                  className="border rounded p-2"
                >
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-xs font-medium truncate flex-1">
                      {file.name}
                    </span>
                    <button
                      id={`order-create-attachment-remove-file-btn-${index}`}
                      onClick={() => removeFile(index)}
                      className="ml-2 text-red-600 hover:text-red-800 text-xs font-bold px-2"
                    >
                      ✕
                    </button>
                  </div>
                  <div className="h-40 overflow-hidden rounded bg-gray-100">
                    {file.type.startsWith("image") ? (
                      <img
                        src={URL.createObjectURL(file)}
                        alt={file.name}
                        className="object-contain w-full h-full"
                      />
                    ) : (
                      <embed
                        src={URL.createObjectURL(file)}
                        type="application/pdf"
                        className="w-full h-full"
                      ></embed>
                    )}
                  </div>
                </div>
              ))}
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <button
                id="order-create-attachment-cancel-btn"
                onClick={props.onClose}
                className="rounded-3xl py-2 px-5 border border-myPrimaryColor text-myPrimaryColor text-sm"
              >
                Cancel
              </button>
              <button
                id="order-create-attachment-submit-btn"
                onClick={() => {
                  if (!category || files.length === 0) {
                    showToast({
                      type: ToastType.error,
                      text: "Category and at least one file required",
                    });
                    return;
                  }

                  // Submit each file individually with the same category
                  files.forEach((file) => {
                    props.onSubmit({ category, file });
                  });
                  props.onClose();
                }}
                className="rounded-3xl py-2 px-5 bg-myPrimaryColor text-white text-sm"
              >
                Submit All
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default UploadAttachmentWidget;
